const PIPELINE_STATUSES = [
  { status: 'Aberta', color: 'warning' },
  { status: 'Análise', color: 'orange' },
  { status: 'Aguardando cliente', color: 'warning' },
  { status: 'Aguardando corretora', color: 'mplan' },
  { status: 'Aguardando operadora', color: 'mplan' },
  { status: 'Aguardando administradora', color: 'mplan' },
  { status: 'Realizar entrevista', color: 'violet' },
  { status: 'Analisar entrevista', color: 'pblue' },
  { status: 'Aguardando CPT(s)', color: 'warning' },
  { status: 'Aprovada', color: 'success' },
  { status: 'Negada', color: 'error' },
  { status: 'Rejeitada', color: 'error' },
  { status: 'Cancelada pelo proponente', color: 'error' }
];

function getStatusMeta(status) {
  return (
    PIPELINE_STATUSES.find((item) => item.status === status) || {
      status: status || 'Outros',
      color: 'primary'
    }
  );
}

function buildPipelineQuery(filters = {}) {
  const params = new URLSearchParams();
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
      params.append(key, filters[key]);
    }
  });
  const query = params.toString();
  return query ? `?${query}` : '';
}

export { PIPELINE_STATUSES, getStatusMeta, buildPipelineQuery };
